import Joi from 'joi';
import {
  atLeastOneNumber,
  containSpecialCharacter,
  phoneExpression,
} from '../../Utils';

// Schema for individual contact

export const createIndividualSchema = (t, ns) =>
  Joi.object({
    firstName: Joi.string()
      .regex(containSpecialCharacter, { invert: true })
      .regex(atLeastOneNumber, { invert: true })
      .required()
      .messages({
        'any.required': t('is-required', { field: t('first_name'), ns }),
        'string.empty': t('is-required', { field: t('first_name'), ns }),
        'string.pattern.invert.base': t('no_special_characters', {
          field: t('first_name'),
        }),
      }),
    lastName: Joi.string()
      .regex(containSpecialCharacter, { invert: true })
      .regex(atLeastOneNumber, { invert: true })
      .required()
      .messages({
        'any.required': t('is-required', { field: t('last_name'), ns }),
        'string.empty': t('is-required', { field: t('last_name'), ns }),
        'string.pattern.invert.base': t('no_special_characters', {
          field: t('last_name'),
        }),
      }),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .messages({
        'string.empty': t('invalid_email', { field: t('email') }),
        'any.required': t('is-required', { field: t('email'), ns }),
        'string.email': t('invalid_email', { field: t('email') }),
      }),
    phone: Joi.string()
      .required()
      .regex(phoneExpression)
      .messages({
        'any.required': t('is-required', { field: t('phone'), ns }),
        'string.empty': t('is-required', { field: t('phone'), ns }),
        'string.pattern.base': t('invalid-mobile-number', { ns: 'HeaderView' }),
      }),
  });
// Schema for corporate contact
export const createCorporateSchema = (t, ns, isEmailRequired) =>
  Joi.object({
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .allow('')
      .custom((value, helpers) => {
        if (isEmailRequired && !value) {
          return helpers.error('any.required');
        }
        return value;
      })
      .messages({
        'any.required': t('is-required', { field: t('email'), ns }),
        'string.email': t('invalid-email', { field: t('email'), ns }),
        'string.empty': t('invalid-email', { field: t('email'), ns }),
      }),
    companyName: Joi.string()
      .required()
      .regex(containSpecialCharacter, { invert: true })
      .regex(atLeastOneNumber, { invert: true })
      .messages({
        'any.required': t('is-required', { field: t('company_name'), ns }),
        'string.empty': t('is-required', { field: t('company_name'), ns }),
        'string.pattern.invert.base': t('no_special_characters', {
          field: t('company_name'),
        }),
      }),
    landline: Joi.string()
      .required()
      .regex(phoneExpression)
      .messages({
        'any.required': t('is-required', { field: t('landline'), ns }),
        'string.empty': t('is-required', { field: t('landline'), ns }),
        'string.pattern.base': t('invalid-mobile-number', { ns: 'HeaderView' }),
      }),
  });
